import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { Observable, of } from 'rxjs';
import { catchError, map, switchMap, tap } from 'rxjs/operators';

import * as rootActions from '../root-actions';
import { AuthHttpService } from '../../../core/services/authorization/auth-http.service';

@Injectable()
export class RootEffects {
    constructor(
        private actions$: Actions<any>,
        private authHttp: AuthHttpService,
        private router: Router,
    ) {}

    @Effect({ dispatch: false })
    loginUser$ = this.actions$.pipe(
        ofType(rootActions.ROOT_LOGIN_USER_SUCCESS),
        map((action: rootActions.LoginUserSuccess) => action.payload),
        tap(loginData => localStorage.setItem('__bt', loginData.token)),
        tap(loginData => {
            if (loginData.ResponseCode === 4000 && !loginData.isNewUser) {
                this.router.navigate(['subscription']);
                localStorage.setItem('subExpired', 'true');
            } else if (loginData.refpage!=null && loginData.refpage!="") {
                this.router.navigate(["/"+loginData.refpage]);
                localStorage.setItem('subExpired', 'true');
            } else {
                this.router.navigate(['overview']);
                localStorage.removeItem('subExpired');
            }
        }),
    );

    @Effect()
    logoutUser$: Observable<Action> = this.actions$.pipe(
        ofType(rootActions.ROOT_LOGOUT_USER),
        switchMap(() => {
            return this.authHttp.logoutUser().pipe(
                map(() => new rootActions.LogoutUserSuccess()),
                tap(() => {
                    localStorage.removeItem('__bt');
                    
                    this.router.navigate(['auth/login']);
                }),
                catchError(error => of(new rootActions.LogoutUserFail())),
            );
        }),
    );
}
